import { render, staticRenderFns } from "./WarningBar.vue?vue&type=template&id=00564c7a"
import script from "./WarningBar.vue?vue&type=script&lang=js"
export * from "./WarningBar.vue?vue&type=script&lang=js"
import style0 from "./WarningBar.vue?vue&type=style&index=0&id=00564c7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports